import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ActionButtons, ConfirmModal, useToast } from "../../../shared/components/SharedUI";
import {
  getAreas, createArea, updateArea, deleteArea,
  createHorario, updateHorario, deleteHorario,
  getCuentasIngreso,
} from "../services/portalService";

export default function AdminAreas() {
  const { t } = useTranslation();
  const { showToast, toastEl } = useToast();
  const imgRef = useRef();

  const [areas, setAreas]           = useState([]);
  const [cuentasIngreso, setCuentas]= useState([]);
  const [loading, setLoading]       = useState(true);
  const [modal, setModal]           = useState(null);
  const [form, setForm]             = useState({});
  const [imageFile, setImageFile]   = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [saving, setSaving]         = useState(false);
  const [err, setErr]               = useState(null);
  const [horarioModal, setHModal]   = useState(null);
  const [hForm, setHForm]           = useState({});
  const [selectedArea, setSelArea]  = useState(null);
  const [confirm, setConfirm]       = useState(null);
  const [deleting, setDeleting]     = useState(false);
  // Which area has its horarios panel expanded
  const [expandedId, setExpandedId] = useState(null);

  function load() {
    getAreas().then(d => setAreas(d.results || d)).catch(() => {}).finally(() => setLoading(false));
  }
  useEffect(() => {
    load();
    getCuentasIngreso().then(d => setCuentas(d)).catch(() => {});
  }, []);

  function openCreate() {
    setForm({ nombre: "", descripcion: "", activa: true, precio_colones: "", precio_dolares: "", cuenta_ingreso: "" });
    setImageFile(null); setImagePreview(null);
    setErr(null); setModal({ mode: "create" });
  }
  function openEdit(a) {
    setForm({
      nombre: a.nombre, descripcion: a.descripcion, activa: a.activa,
      precio_colones: a.precio_colones ?? "", precio_dolares: a.precio_dolares ?? "",
      cuenta_ingreso: a.cuenta_ingreso_id ?? "",
    });
    setImageFile(null);
    setImagePreview(a.imagen_url || null);
    setErr(null); setModal({ mode: "edit", id: a.id });
  }

  function handleImageChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  }

  async function handleSaveArea() {
    setSaving(true); setErr(null);
    try {
      const fd = new FormData();
      fd.append("nombre", form.nombre);
      fd.append("descripcion", form.descripcion);
      fd.append("activa", form.activa ? "true" : "false");
      if (form.precio_colones !== "" && form.precio_colones !== null) fd.append("precio_colones", form.precio_colones);
      if (form.precio_dolares !== "" && form.precio_dolares !== null) fd.append("precio_dolares", form.precio_dolares);
      if (form.cuenta_ingreso !== "" && form.cuenta_ingreso !== null) fd.append("cuenta_ingreso", form.cuenta_ingreso);
      else fd.append("cuenta_ingreso", "");
      if (imageFile) fd.append("imagen", imageFile);
      if (modal.mode === "create") await createArea(fd);
      else await updateArea(modal.id, fd);
      showToast(t("common.guardado"), true);
      setModal(null); load();
    } catch (e) {
      try { const d = JSON.parse(e.message); setErr(Object.values(d).flat().join(". ")); }
      catch { setErr(e.message); }
    } finally { setSaving(false); }
  }

  async function handleDelete() {
    setDeleting(true);
    try {
      if (confirm.type === "area") await deleteArea(confirm.id);
      else await deleteHorario(confirm.id);
      showToast(t("common.eliminado"), true);
      setConfirm(null); load();
    } catch { showToast(t("common.errorEliminar"), false); }
    finally { setDeleting(false); }
  }

  function openNewHorario(area) {
    setSelArea(area);
    setHForm({ nombre: "", hora_inicio: "", hora_fin: "", activo: true });
    setErr(null); setHModal({ mode: "create" });
  }
  function openEditHorario(area, h) {
    setSelArea(area);
    setHForm({ nombre: h.nombre, hora_inicio: h.hora_inicio, hora_fin: h.hora_fin, activo: h.activo });
    setErr(null); setHModal({ mode: "edit", id: h.id });
  }

  async function handleSaveHorario() {
    setSaving(true); setErr(null);
    try {
      if (horarioModal.mode === "create") await createHorario({ ...hForm, area: selectedArea.id });
      else await updateHorario(horarioModal.id, hForm);
      showToast(t("common.guardado"), true);
      setHModal(null); load();
    } catch (e) {
      try { const d = JSON.parse(e.message); setErr(Object.values(d).flat().join(". ")); }
      catch { setErr(e.message); }
    } finally { setSaving(false); }
  }

  const textField = (obj, setObj, key, label, type = "text", placeholder = "") => (
    <div style={{ marginBottom: 14 }}>
      <label style={{ fontSize: 12, fontWeight: 700, color: "var(--text-secondary)", display: "block", marginBottom: 6, letterSpacing: 0.5 }}>{label}</label>
      <input type={type} value={obj[key] ?? ""} placeholder={placeholder}
        onChange={e => setObj(f => ({ ...f, [key]: e.target.value }))}
        className="form-control" />
    </div>
  );

  const modalFooter = (onSave) => (
    <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 4 }}>
      <button onClick={() => { setModal(null); setHModal(null); }} style={{
        padding: "9px 18px", borderRadius: 8, border: "1px solid var(--border-input)",
        background: "var(--hover-bg)", color: "var(--text-secondary)", cursor: "pointer", fontSize: 14,
      }}>
        {t("common.cancelar")}
      </button>
      <button onClick={onSave} disabled={saving} style={{
        padding: "9px 20px", borderRadius: 8, border: "none",
        background: "#f97316", color: "#fff", fontWeight: 700, fontSize: 14,
        cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.7 : 1,
      }}>
        {saving ? t("common.cargando") : t("common.guardar")}
      </button>
    </div>
  );

  return (
    <div style={{ padding: "24px" }}>
      {toastEl}
      <ConfirmModal open={!!confirm} name={confirm?.name} onConfirm={handleDelete} onCancel={() => setConfirm(null)} loading={deleting} />

      {/* Breadcrumb */}
      <span style={{ color: "var(--text-secondary)", fontWeight: 400 }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <span style={{ color: "var(--text-secondary)", fontWeight: 400 }}>Portal Admin /</span>
        </Link>
        <span style={{ color: "var(--text-primary)", fontWeight: 600 }}> {t("portal.areasComunes")}</span>
      </span>

      {/* Header */}
      <div className="d-flex justify-content-between align-items-start flex-wrap gap-2" style={{ marginBottom: 20 }}>
        <div>
          <h2 className="mt-2 me-2 p-0 title">{t("portal.areasComunes")}</h2>
          <p className="mb-3" style={{ color: "var(--text-muted)" }}>{t("portal.areasComunesDesc")}</p>
        </div>
        <button onClick={openCreate} style={{
          background: "#f97316", color: "#fff", border: "none", borderRadius: 8,
          padding: "9px 16px", cursor: "pointer", fontWeight: 700, fontSize: 13,
          display: "flex", alignItems: "center", gap: 6, marginTop: 8,
        }}>
          <i className="fa-solid fa-plus" /> {t("portal.nueva")}
        </button>
      </div>

      {loading ? (
        <p style={{ textAlign: "center", color: "var(--text-secondary)" }}>{t("common.cargando")}</p>
      ) : areas.length === 0 ? (
        <div style={{ textAlign: "center", color: "var(--text-secondary)", padding: 48 }}>
          <i className="fa-solid fa-building" style={{ fontSize: 40, opacity: 0.4, marginBottom: 12, display: "block" }} />
          <p style={{ margin: 0 }}>{t("portal.sinAreas")}</p>
        </div>
      ) : (
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
          gap: 14,
        }}>
          {areas.map(a => {
            const isExpanded = expandedId === a.id;
            return (
              <div key={a.id} style={{
                background: "var(--bg-card)",
                border: "1px solid var(--border-card)",
                borderRadius: 12,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}>
                {/* Compact image strip */}
                {a.imagen_url ? (
                  <img src={a.imagen_url} alt={a.nombre}
                    style={{ width: "100%", height: 100, objectFit: "cover", display: "block", flexShrink: 0 }} />
                ) : (
                  <div style={{
                    width: "100%", height: 60, flexShrink: 0,
                    background: "rgba(249,115,22,0.08)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    <i className="fa-solid fa-building" style={{ fontSize: 22, color: "#f97316", opacity: 0.5 }} />
                  </div>
                )}

                {/* Card body */}
                <div style={{ padding: "12px 14px", flex: 1, display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
                    <div style={{ flex: 1, minWidth: 0, marginRight: 8 }}>
                      <p style={{ margin: 0, fontWeight: 700, fontSize: 14, color: "var(--text-primary)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {a.nombre}
                      </p>
                      {a.descripcion && (
                        <p style={{
                          margin: "2px 0 0", fontSize: 12, color: "var(--text-secondary)",
                          display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden",
                        }}>
                          {a.descripcion}
                        </p>
                      )}
                    </div>
                    <ActionButtons
                      onEdit={() => openEdit(a)}
                      onDelete={() => setConfirm({ id: a.id, name: a.nombre, type: "area" })}
                    />
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
                    {!a.activa && (
                      <span style={{
                        background: "rgba(156,163,175,0.1)", border: "1px solid rgba(156,163,175,0.3)",
                        color: "#9ca3af", borderRadius: 20, padding: "2px 8px", fontSize: 10, fontWeight: 700,
                      }}>
                        {t("portal.inactiva")}
                      </span>
                    )}
                    <span style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                      {a.horarios?.length || 0} {t("portal.horarios")}
                    </span>
                  </div>
                  {(a.precio_colones || a.precio_dolares) && (
                    <div style={{ display: "flex", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
                      {a.precio_colones && (
                        <span style={{ fontSize: 11, fontWeight: 700, color: "#10b981" }}>
                          ₡{Number(a.precio_colones).toLocaleString("es-CR")}
                        </span>
                      )}
                      {a.precio_dolares && (
                        <span style={{ fontSize: 11, fontWeight: 700, color: "#3b82f6" }}>
                          ${Number(a.precio_dolares).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                        </span>
                      )}
                    </div>
                  )}

                  {/* Toggle horarios */}
                  <button onClick={() => setExpandedId(isExpanded ? null : a.id)} style={{
                    background: "none", border: "1px solid var(--border-card)", borderRadius: 8,
                    padding: "5px 10px", cursor: "pointer", fontSize: 12,
                    color: "var(--text-secondary)", display: "flex", alignItems: "center", gap: 6,
                    width: "100%", justifyContent: "center",
                  }}>
                    <i className={`fa-solid fa-chevron-${isExpanded ? "up" : "down"}`} style={{ fontSize: 10 }} />
                    {isExpanded ? t("portal.ocultarHorarios") || "Ocultar horarios" : t("portal.verHorarios") || "Ver horarios"}
                  </button>

                  {/* Horarios panel */}
                  {isExpanded && (
                    <div style={{ marginTop: 10, borderTop: "1px solid var(--border-card)", paddingTop: 10 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: "var(--text-secondary)", textTransform: "uppercase", letterSpacing: 1 }}>
                          {t("portal.horarios")}
                        </span>
                        <button onClick={() => openNewHorario(a)} style={{
                          background: "rgba(249,115,22,0.1)", border: "1px solid rgba(249,115,22,0.3)",
                          color: "#f97316", borderRadius: 6, padding: "3px 8px",
                          cursor: "pointer", fontSize: 11, fontWeight: 700,
                        }}>
                          + {t("portal.agregarHorario")}
                        </button>
                      </div>
                      {!a.horarios?.length ? (
                        <p style={{ color: "var(--text-secondary)", fontSize: 12, margin: 0 }}>{t("portal.sinHorarios")}</p>
                      ) : (
                        a.horarios.map(h => (
                          <div key={h.id} style={{
                            display: "flex", justifyContent: "space-between", alignItems: "center",
                            padding: "6px 0", borderBottom: "1px solid var(--border-card)",
                          }}>
                            <div>
                              <span style={{ fontSize: 12, fontWeight: 600, color: h.activo ? "var(--text-primary)" : "var(--text-secondary)" }}>{h.nombre}</span>
                              <span style={{ fontSize: 11, color: "var(--text-secondary)", marginLeft: 6 }}>{h.hora_inicio} – {h.hora_fin}</span>
                              {!h.activo && <span style={{ marginLeft: 4, fontSize: 10, color: "#9ca3af" }}>(inactivo)</span>}
                            </div>
                            <ActionButtons
                              onEdit={() => openEditHorario(a, h)}
                              onDelete={() => setConfirm({ id: h.id, name: h.nombre, type: "horario" })}
                            />
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ── Area Modal ── */}
      {modal && (
        <div onClick={() => setModal(null)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)", backdropFilter: "blur(3px)",
          zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "var(--bg-card)", border: "1px solid var(--border-card)",
            borderRadius: 14, width: "min(560px,94vw)",
            boxShadow: "0 24px 64px var(--shadow)", maxHeight: "90vh", overflowY: "auto",
          }}>
            <h2 style={{ fontSize: 17, fontWeight: 700, color: "var(--text-primary)", margin: 0, padding: "20px 24px 0" }}>
              {modal.mode === "create" ? t("portal.crearArea") : t("portal.editarArea")}
            </h2>

            <div style={{ padding: "16px 24px 24px" }}>
              {/* Image upload */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: "var(--text-secondary)", display: "block", marginBottom: 8, letterSpacing: 0.5 }}>
                  {t("portal.imagenArea")}
                </label>
                <div
                  onClick={() => imgRef.current?.click()}
                  style={{
                    borderRadius: 10, overflow: "hidden", cursor: "pointer",
                    border: `2px dashed ${imagePreview ? "#f97316" : "var(--border-input)"}`,
                    background: imagePreview ? "transparent" : "var(--hover-bg)",
                    minHeight: 140, position: "relative",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    transition: "border-color .15s",
                  }}
                >
                  {imagePreview ? (
                    <>
                      <img src={imagePreview} alt="preview"
                        style={{ width: "100%", height: 180, objectFit: "cover", display: "block" }} />
                      <div style={{
                        position: "absolute", inset: 0, background: "rgba(0,0,0,0.4)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        opacity: 0, transition: "opacity .15s",
                      }}
                        onMouseEnter={e => e.currentTarget.style.opacity = 1}
                        onMouseLeave={e => e.currentTarget.style.opacity = 0}
                      >
                        <span style={{ color: "#fff", fontSize: 13, fontWeight: 700 }}>
                          <i className="fa-solid fa-camera" style={{ marginRight: 6 }} />
                          {t("portal.cambiarImagen")}
                        </span>
                      </div>
                    </>
                  ) : (
                    <div style={{ textAlign: "center", padding: 24 }}>
                      <i className="fa-solid fa-image" style={{ fontSize: 32, color: "var(--text-secondary)", opacity: 0.4, display: "block", marginBottom: 8 }} />
                      <p style={{ margin: 0, fontSize: 13, color: "var(--text-secondary)" }}>{t("portal.subirImagen")}</p>
                      <p style={{ margin: "4px 0 0", fontSize: 11, color: "var(--text-secondary)", opacity: 0.6 }}>JPG, PNG, WebP</p>
                    </div>
                  )}
                </div>
                <input ref={imgRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleImageChange} />
                {imagePreview && (
                  <button type="button" onClick={() => { setImageFile(null); setImagePreview(null); if (imgRef.current) imgRef.current.value = ""; }} style={{
                    marginTop: 6, background: "rgba(248,113,113,0.1)", border: "1px solid rgba(248,113,113,0.3)",
                    color: "#f87171", borderRadius: 6, padding: "3px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600,
                  }}>
                    <i className="fa-solid fa-trash" style={{ marginRight: 4 }} />{t("common.limpiar")}
                  </button>
                )}
              </div>

              {textField(form, setForm, "nombre", t("portal.nombre"))}

              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: "var(--text-secondary)", display: "block", marginBottom: 6, letterSpacing: 0.5 }}>
                  {t("portal.descripcion")}
                </label>
                <textarea value={form.descripcion ?? ""} rows={3}
                  onChange={e => setForm(f => ({ ...f, descripcion: e.target.value }))}
                  className="form-control" style={{ resize: "vertical", width: "100%", boxSizing: "border-box" }} />
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                <input type="checkbox" checked={!!form.activa}
                  onChange={e => setForm(f => ({ ...f, activa: e.target.checked }))}
                  style={{ width: 16, height: 16, accentColor: "#f97316" }} />
                <label style={{ fontSize: 13, color: "var(--text-primary)" }}>{t("portal.activa")}</label>
              </div>

              {/* Precios */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 700, color: "var(--text-secondary)", display: "block", marginBottom: 6, letterSpacing: 0.5 }}>
                    {t("portal.precioColones") || "Precio (₡)"}
                  </label>
                  <input type="number" min="0" step="0.01" value={form.precio_colones ?? ""}
                    onChange={e => setForm(f => ({ ...f, precio_colones: e.target.value }))}
                    className="form-control" placeholder="0.00" />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 700, color: "var(--text-secondary)", display: "block", marginBottom: 6, letterSpacing: 0.5 }}>
                    {t("portal.precioDolares") || "Precio ($)"}
                  </label>
                  <input type="number" min="0" step="0.01" value={form.precio_dolares ?? ""}
                    onChange={e => setForm(f => ({ ...f, precio_dolares: e.target.value }))}
                    className="form-control" placeholder="0.00" />
                </div>
              </div>

              {/* Cuenta de ingreso */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: "var(--text-secondary)", display: "block", marginBottom: 6, letterSpacing: 0.5 }}>
                  {t("portal.cuentaIngreso") || "Cuenta de ingreso"}
                </label>
                <select value={form.cuenta_ingreso ?? ""} onChange={e => setForm(f => ({ ...f, cuenta_ingreso: e.target.value }))} className="form-control">
                  <option value="">{t("portal.sinCuenta") || "— Sin cuenta —"}</option>
                  {cuentasIngreso.map(c => (
                    <option key={c.id} value={c.id}>{c.codigo} — {c.nombre}</option>
                  ))}
                </select>
              </div>

              {err && (
                <div style={{
                  background: "rgba(248,113,113,0.08)", border: "1px solid rgba(248,113,113,0.3)",
                  borderLeft: "4px solid #f87171", borderRadius: 8, padding: "10px 14px",
                  color: "#f87171", fontSize: 13, marginBottom: 14,
                }}>
                  {err}
                </div>
              )}
              {modalFooter(handleSaveArea)}
            </div>
          </div>
        </div>
      )}

      {/* ── Horario Modal ── */}
      {horarioModal && (
        <div onClick={() => setHModal(null)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)", backdropFilter: "blur(3px)",
          zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "var(--bg-card)", border: "1px solid var(--border-card)",
            borderRadius: 14, padding: 24, width: "min(480px,94vw)",
            boxShadow: "0 24px 64px var(--shadow)",
          }}>
            <h2 style={{ fontSize: 17, fontWeight: 700, color: "var(--text-primary)", margin: "0 0 4px" }}>
              {horarioModal.mode === "create" ? t("portal.agregarHorario") : t("portal.editarHorario")}
            </h2>
            <p style={{ fontSize: 13, color: "var(--text-secondary)", margin: "0 0 20px" }}>{selectedArea?.nombre}</p>
            {textField(hForm, setHForm, "nombre", t("portal.nombreHorario"), "text", "Ej: Mañana, Tarde")}
            {textField(hForm, setHForm, "hora_inicio", t("portal.horaInicio"), "time")}
            {textField(hForm, setHForm, "hora_fin", t("portal.horaFin"), "time")}
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
              <input type="checkbox" checked={!!hForm.activo}
                onChange={e => setHForm(f => ({ ...f, activo: e.target.checked }))}
                style={{ width: 16, height: 16, accentColor: "#f97316" }} />
              <label style={{ fontSize: 13, color: "var(--text-primary)" }}>{t("portal.activo")}</label>
            </div>
            {err && (
              <div style={{
                background: "rgba(248,113,113,0.08)", border: "1px solid rgba(248,113,113,0.3)",
                borderLeft: "4px solid #f87171", borderRadius: 8, padding: "10px 14px",
                color: "#f87171", fontSize: 13, marginBottom: 14,
              }}>
                {err}
              </div>
            )}
            {modalFooter(handleSaveHorario)}
          </div>
        </div>
      )}
    </div>
  );
}
